import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH_CLIENT_CARD = ConstantList.API_EN_POINT + "/treatment-plan-card";
const API_PATH_DRUG_ORDER = ConstantList.API_EN_POINT + "/drug";

export const pagingTreatmentPlanCard = (obj) =>
  axios.post(API_PATH_CLIENT_CARD + "/search-by-page-by-user", obj);

export const searchTreatmentPlanCardReport = (obj) =>
  axios.post(API_PATH_CLIENT_CARD + "/search-treatment-plan-card-report", obj);

export const getTreatmentPlanCardById = (id) =>
  axios.get(API_PATH_CLIENT_CARD + "/get-by-id/" + id);

export const saveOrEditTreatmentPlanCard = (id) =>
  axios.post(API_PATH_CLIENT_CARD + "/save-card-with-pa-sv-register", id);

export const deleteTreatmentPlanCard = (id) =>
  axios.delete(API_PATH_CLIENT_CARD + "/mark-delete/" + id);

export const removeTreatmentPlanCard = (id) =>
  axios.delete(API_PATH_CLIENT_CARD + "/remove-treatment-plan-card/" + id);

export const removeDrug = (id) =>
  axios.delete(API_PATH_DRUG_ORDER + "/remove-drug-order/" + id);

export const getDrugOderById = (id) =>
  axios.get(API_PATH_DRUG_ORDER + "/get-by-id-drug-order/" + id);

// export const getTreatmentPlanCardById = (id) =>
//   axios.get(API_PATH_CLIENT_CARD + "/get-by-id/" + id);

export const getListTreatmentPlanCard = (obj) =>
  axios.post(
    API_PATH_CLIENT_CARD + "/get-list-treatment-plan-card-patient-advice",
    obj
  );

export const getListPrepaidCard = (obj) =>
  axios.post(
    API_PATH_CLIENT_CARD + "/get-list-prepaid-card-patient-advice",
    obj
  );

export const removeTreatmentPlanCardUser = (id) =>
  axios.delete(API_PATH_CLIENT_CARD + "/remove-treatment-plan-card-user/" + id);

export const getInitChangeTreatment = (id) =>
  axios.get(API_PATH_CLIENT_CARD + "/init-change-treatment/" + id);
export const changeTreatment = (obj) =>
  axios.post(API_PATH_CLIENT_CARD + "/change-treatment", obj);

export const unLockTreatment = (id) =>
  axios.get(API_PATH_CLIENT_CARD + "/un-lock-treatment/" + id);

export const searchByPageBySyncCard = (obj) =>
  axios.post(API_PATH_CLIENT_CARD + "/search-by-page-by-sync-card", obj);

export const lockTreatment = (id) =>
  axios.post(API_PATH_CLIENT_CARD + "/lock-treatment-plan-card/" + id);

export const getPromotionProgramsByClient = (obj) =>
  axios.post(API_PATH_CLIENT_CARD + "/get-promotion-programs-by-client", obj);

export const applyPromotionProgram = (obj) =>
  axios.post(API_PATH_CLIENT_CARD + "/apply-promotion", obj);